import angular from 'angular';
import uiRouter from 'angular-ui-router';
import assignationsComponent from './assignations.component';
import dataTable from 'angular-material-data-table';

const assignationsModule = angular
  .module('assignations', [uiRouter, dataTable])
  .config([
    '$stateProvider',
    $stateProvider => {
      'ngInject';
      $stateProvider.state('assignations', {
        url: '/assignations',
        component: 'assignations',
        parent: 'main',
        data: {
          permissions: {
            only: ['AUTHORIZED'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      });
    }
  ])
  .component('assignations', assignationsComponent).name;

export default assignationsModule;
